module.exports = __webpack_public_path__ + "static/img/bigweibo.4fa1196.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobiigw/bigweibo.png
// module id = NjFL
// module chunks = 1